import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen w-full py-8 px-4 sm:px-6 lg:px-8"
      style={{
        background: "linear-gradient(180deg, #FCE8E9 0%, #FFF 100%)",
      }}
    >
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            className="text-[#e61f26] hover:text-[#c01a21] font-Poppins font-[500]"
          >
            Back
          </Button>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 md:p-12">
          <div className="mb-8 border-b border-gray-200 pb-6">
            <h1 className="font-Poppins text-3xl sm:text-4xl md:text-5xl font-[700] text-[#010101] mb-3">
              Privacy Policy
            </h1>
            <p className="font-Poppins text-lg sm:text-xl font-[600] text-[#e61f26]">
              ProTVGuide SportsBot
            </p>
            <p className="font-Poppins text-sm sm:text-base font-[400] text-[#667085] mt-2">
              Effective Date: October 1, 2025
            </p>
          </div>

          <div className="mb-6 p-4 bg-[#FCE8E9] rounded-lg border-l-4 border-[#e61f26]">
            <p className="font-Poppins text-sm sm:text-base font-[500] text-[#344054]">
              At ProTVGuide SportsBot, your privacy is our top priority. We believe your data belongs to you, and we will never sell, share, or disclose it to anyone — for any reason.
            </p>
          </div>

          <div className="space-y-8">
            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  1
                </span>
                Information We Collect
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  Minimal information necessary to provide the service (e.g., Discord ID, Telegram ID, email if provided, subscription/payment info).
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  Usage data (e.g., sports preferences, schedule posting activity) strictly for improving the service.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  2
                </span>
                How We Use Your Information
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  To deliver daily sports schedules and bot features.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  To process subscriptions and chat credits if you choose to purchase them.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  To improve service reliability and functionality.
                </p>                
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  3
                </span>
                What We Do Not Do
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  We do not sell, rent, or share your information with third parties.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  We do not use your data for advertising or profiling.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  4
                </span>
                Your Rights
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  You may request deletion of your data at any time. Once confirmed, all associated information will be permanently removed from our systems.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  You may request a copy of the data we hold about you.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  5
                </span>
                Data Retention
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  We only keep data for as long as necessary to provide services.
                </p>
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  Backups and logs rotate out regularly, and deleted data will not be restored.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-Poppins text-xl sm:text-2xl font-[700] text-[#010101] mb-1 flex items-center">
                <span className="inline-block w-8 h-8 sm:w-10 sm:h-10 bg-[#e61f26] text-white rounded-full flex items-center justify-center mr-3 text-base sm:text-lg">
                  6
                </span>
                Contact Us
              </h2>
              <div className="ml-11 sm:ml-13 space-y-2">
                <p className="font-Poppins text-sm sm:text-base font-[400] text-[#344054] leading-relaxed text-left">
                  For privacy or data removal requests, email privacy@protvguide.com
                </p>
              </div>
            </section>

          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="font-Poppins text-xs sm:text-sm font-[400] text-[#667085]">
            © 2025 ProTVGuide SportsBot. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;